import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from 'react-select'
// Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

// utils
import { validateInput, COUNTRIES } from "Services/Utils/validateInput";
// import { notifySuccess } from "Services/Utils/toastNotification";
import { fetchCountryCode } from "../../../../Redux/Slices/countrySlice";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";

// redux
import { useDispatch } from "react-redux";
import { editUser, fetchIndividualUser, fetchUserManagementCompany, fetchUserManagementIndustry } from "../../../../Redux/Slices/userManagementSlice";
import { fetchCompanyManagementCompany } from "../../../../Redux/Slices/companyManagementSlice";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [companyType, setCompanyType] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [userName, setUserName] = useState("")
  const [mobile, setMobile] = useState("")
  const [department, setDepartment] = useState("")
  const [position, setPosition] = useState("")
  const [email, setEmail] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [companyList,setCompanyList] = useState([]);
  const [industryList,setIndustryList] = useState([]);
  const [countryCode,setCountryCode] = useState("")

  const COUNTRY_CODES = Object.entries(COUNTRIES).map(([code, name]) => ({
    value: code,
  label: `${name} (${code})`
})).sort((a, b) => a.label.localeCompare(b.label));
 
 // Fetch country data once when the app starts
      useEffect(() => {
        dispatch(fetchCountryCode());
      }, [dispatch]);
  
  // const dropDownStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     border: "1px solid #B2BEC3",
  //     boxShadow: "none",
  //     padding: "5px 3px",
  //     fontFamily: "Poppins",
  //     fontSize: "2.2vh",
  //     marginRight: "10px",
  //     height: "7vh",
  //     width:"33vw",
  //   }),
  //   menu: (provided) => ({
  //     ...provided,
  //     color: "#697077",
  //   }),
  //   option: (provided) => ({
  //     ...provided,
  //     color: "#697077",
  //   }),
  //   singleValue: (provided) => ({
  //     ...provided,
  //     color: "#697077",
  //   }),
  //   indicatorSeparator: () => ({ display: "none" }),
  // };

  const inputBoxStyles = {
    boxShadow: "none",
    border: "1px solid #B2BEC3",
    padding: "1px 2vh 1px 2vh",
    height: "7vh",
    color: "#697077",
    fontSize: "2.2vh",

  };

  const phoneInputStyles = {
    container: {
      display: 'flex',
      // width: '33vw',
      border: '1px solid #B2BEC3',
      borderRadius: '4px',
      height: '7vh',
    },
    countryCodeSelect: {
      height: '7vh',
      width: '200px', 
      border: 'none',
      borderRight: '1px solid #B2BEC3',
      borderRadius: '4px 0 0 4px',
      backgroundColor: 'white',
      color: '#697077',
      fontSize: '2.2vh',
      padding: '0 10px',
      cursor: 'pointer',
    },
    numberInput: {
      width: '50%', 
      border: 'none',
      borderRadius: '0 4px 4px 0',
      padding: '0 2vh',
      color: '#697077',
      fontSize: '2.2vh',
      outline: 'none',
    }
  };

  const handleValidation = () => {
    let validationErrors = {};

    // const validateCompanyType = validateInput("companyType", companyType);
    // if (validateCompanyType.companyType) {
    //   validationErrors.companyType = validateCompanyType.companyType;
    // }

    const validateIndustry = validateInput("industry", industry);
    if (validateIndustry.industry) {
      validationErrors.industry = validateIndustry.industry;
    }
    const validateUserName = validateInput("username", userName);
    if (validateUserName.username) {
      validationErrors.userName = validateUserName.username;
    }
    const validateMobile = validateInput("mobile", mobile, "",countryCode);
    if (validateMobile.mobile) {
      validationErrors.mobile = validateMobile.mobile;
    }
    // const validateDepartment = validateInput("department", department);
    // if (validateDepartment.department) {
    //   validationErrors.department = validateDepartment.department;
    // }
    // const validatePosition = validateInput("position", position);
    // if (validatePosition.position) {
    //   validationErrors.position = validatePosition.position;
    // }
    const validateEmail = validateInput("email", email);
    if (validateEmail.email) {
      validationErrors.email = validateEmail.email;
    }
    const validateCompanyName = validateInput("companyName", companyName);
    if (validateCompanyName.companyName) {
      validationErrors.companyName = validateCompanyName.companyName;
    }
    setErrors(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    console.log("dgd")
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      const data = {
        "user_id": id,
        "firstname": userName,
        "lastname": " ",
        "mobile": mobile,
        "country_code": countryCode,
        "email": email,
        // "company_type_id": companyType.company_type_id,
        "company_name": companyName,
        // "company_type": companyType.company_type_name,
        "position_type": 3,
        "position_name": position,
        "industry_name": industry.industry_name,
        "industry_type": industry.industry_type_id,
        ...(department && { department }),
        };

      console.log(data,"dfgdf")
      const editUserCB = () => {
        setIsSuccess(true);
      };

      dispatch(
        editUser({
          data: data,
          callBack: editUserCB,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      fetchCompanyManagementCompany({
        callBack: getCompanyCB,
      })
    );
    dispatch(
      fetchUserManagementIndustry({
        callBack: getIndustryCB,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      fetchIndividualUser({
        data: {id},
        callBack: getUserCB,
      })
    );
  }, [companyList,industryList])

  const getUserCB = (value) => {
    console.log(value.data.user)
    const data = value.data.user
    setUserName(data.firstname)
    setMobile(data.mobile)
    setEmail(data.email)
    setCompanyName(data.company_name)
    setPosition(data.position_name)
    setDepartment(data?.department)
    setCountryCode(data.country_code)
    const matchingCompany = companyList.find(
      (item)=> item.company_type_id === data.company_type_id
    )
    if(matchingCompany){
      setCompanyType(matchingCompany)
    }
    const matchingIndustry = industryList.find(
     (item) => item.industry_type_id === data.industry_type
    )
    if(matchingIndustry){
      setIndustry(matchingIndustry)
    }
  }
  const getCompanyCB = (value) => {
    // console.log(value.data)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map(item => ({
      ...item,
      label: item.company_type_name,
      value: item.company_type_id
    }));
    setCompanyList(updatedCategories)
  }
  const getIndustryCB = (value) => {
    // console.log(value.data)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map(item => ({
      ...item,
      label: item.industry_name,
      value: item.industry_type_id
    }));
    setIndustryList(updatedCategories)
  }

    const handleCountryCodeChange = (e) => {
      setCountryCode(e.target.value); 
    };
  
    const handleMobileChange = (e) => {
      setMobile(e.target.value); 
    };

  return (
    <MainLayout pageName={"User Management"}>
      {isSuccess && (
        <SuccessCard
          title="User Edited Successfully"
          subTitle="User Details Updated Successfully."
          onClose={() => setIsSuccess(false)}
          onGoBack={() => navigate(-1)}
        />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Users</p>
      </div>
      <form className="EditUserContainer" >
        <div className="EditUserContainerHeader">
          <h2>Edit User Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        <div className="EditUserInputBoxBody">
        <div className="EditUserInputContainer">
            <p>User Name</p>
            <div className="EditUserInputBoxContainer">
              <InputBox
                inputStyle={inputBoxStyles}
                name="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
              {errors.userName && <ErrorMessage message={errors.userName} />}
            </div>
          </div>
          <div className="EditUserInputContainer">
            <p>Mobile Number</p>
            <div className="EditUserInputBoxContainer">
                  <div style={phoneInputStyles.container}>
                  <Select 
                    options={COUNTRY_CODES}
                    value={COUNTRY_CODES.find(option => option.value === countryCode)}
                    onChange={(selectedOption) => setCountryCode(selectedOption ? selectedOption.value : '')}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        ...phoneInputStyles.countryCodeSelect,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                    <input
                      style={phoneInputStyles.numberInput}
                      type="tel"
                      value={mobile}
                      onChange={handleMobileChange}
                      placeholder={"Enter phone number"}
                    />
                  </div>
              {errors.mobile && <ErrorMessage message={errors.mobile} />}
            </div>
          </div>
          <div className="EditUserInputContainer">
            <p>Email ID</p>
            <div className="EditUserInputBoxContainer">
              <InputBox
                disabled={true}
                inputStyle={inputBoxStyles}
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <ErrorMessage message={errors.email} />}
            </div>
          </div>
          <div className="EditUserInputContainer">
            <p>Company Name</p>
            <div className="EditUserInputBoxContainer">
              <InputBox
                disabled={true}
                inputStyle={inputBoxStyles}
                name="companyName"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
              {errors.companyName && <ErrorMessage message={errors.companyName} />}
            </div>
          </div>
          {/* <div className="EditUserInputContainer">
            <p>Company Type</p>
            <div className="EditUserInputBoxContainer">
              <DropDownBox
                options={companyList}
                placeholder="Select Here"
                onChange={(option) => setCompanyType(option)}
                value={companyType}
                customStyles={dropDownStyles}
              />
              {errors.companyType && <ErrorMessage message={errors.companyType} />}
            </div>
          </div> */}
          {/* <div className="EditUserInputContainer">
            <p>Industry</p>
            <div className="EditUserInputBoxContainer">
              <DropDownBox
                options={industryList}
                placeholder="Select Here"
                onChange={(option) => setIndustry(option)}
                value={industry}
                customStyles={dropDownStyles}
              />
              {errors.industry && <ErrorMessage message={errors.industry} />}
            </div>
          </div> */}
          <div className="EditUserInputContainer">
            <p>Department</p>
            <div className="EditUserInputBoxContainer">
              <InputBox
                inputStyle={inputBoxStyles}
                name="department"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              />
              {errors.department && <ErrorMessage message={errors.department} />}
            </div>
          </div>
          <div className="EditUserInputContainer">
            <p>Position</p>
            <div className="EditUserInputBoxContainer">
              <InputBox
                inputStyle={inputBoxStyles}
                name="position"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
              />
              {errors.position && <ErrorMessage message={errors.position} />}
            </div>
          </div>
        </div>
      </form>
      <div className="editUserButtons">
          <div className="editUserButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#F5F5F5" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="editUserButtonContainer">
            <Button  buttonStyle={{ height: "2vh" }} title="Update" onClick={handleSubmit}/>
          </div>
        </div>
    </MainLayout>
  );
};

export default EditUser;
